import isErrorReportable from 'ui-forms-embed-components-reporting/reporting/internal/isErrorReportable';
import reportErrorToLogFetch from 'ui-forms-embed-components-reporting/reporting/internal/reportErrorToLogFetch';
const reportError = (formInfo, projectInfo, errorInfo) => {
  const {
    env,
    hublet,
    formId,
    portalId,
    pageUrl
  } = formInfo;
  const {
    renderVersion,
    projectVersion,
    module
  } = projectInfo;
  const {
    key,
    error,
    data
  } = errorInfo;
  if (isErrorReportable(error)) {
    const originPageUrl = new URL(pageUrl);
    reportErrorToLogFetch('error', error, {
      type: 'Error',
      env,
      hublet,
      url: originPageUrl.href,
      query: originPageUrl.search,
      tags: {
        renderVersion,
        projectVersion,
        key,
        module
      },
      extra: {
        key,
        data: JSON.stringify(data),
        formId,
        portalId
      }
    });
  }
};
export default reportError;